<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Select a service category
    </ion-title>
    <ion-buttons slot="end">
      <ion-button icon-only [disabled]="errorOccurredWhileLoadingServiceCategories" (click)="onCreateServiceCategory()">
        <ion-icon name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingServiceCategories" (click)="loadServiceCategories()"></salonmonster-tap-retry>

  <ion-item *ngIf='salonServiceCategories.count() === 0'>
    No service categories
  </ion-item>

  <ion-list>
    <ion-item *ngFor="let serviceCategory of salonServiceCategories">
      <ion-button fill="clear"
        (click)="onServiceCategorySelect(serviceCategory)"
        >
        {{ serviceCategory.categoryName }}
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>